export const ADD_PAGES_DATA = 'ADD_PAGES_DATA';
export const CLEAR_PAGES = 'CLEAR_PAGES';

const INITIAL_STATE = {
  pages: [],
  isLoaded: false,
};

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ADD_PAGES_DATA:
      return {
        pages: [...action.payload],
        isLoaded: true,
      };
    case CLEAR_PAGES:
      return INITIAL_STATE;
    default:
      return state;
  }
}
